import request from '@/utils/request'

export function getTaskCfg() {
  return request({
    url: 'api/v1/tetris-task/conf',
    method: 'post'
  })
}

export function updateTaskCfg(data) {
  return request({
    url: 'api/v1/tetris-task/update',
    method: 'post',
    data: data
  })
}
